var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2.499 4.5V0.5H9.75L11.5 2.25V11.5H2M9 0.5V3H11.5M1 6H3.5M2.25 6V9.5M8 6H10.5M9.25 6V9.5M7.25 5.75L4.25 9.25M4.25 5.75L7.25 9.25",
          stroke: "#004EEB",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }